import '../../../styles/skelton/banner-skelton.scss';

export const BannerSkeleton = () => {
  return (
    <div className="banner-skeleton">
      <div className="skeleton-banner-image"></div>
      <div className="skeleton-content">
        <div className="skeleton-title"></div>
        <div className="skeleton-subtitle"></div>
        <div className="skeleton-buttons">
          <div className="skeleton-button"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    </div>
  );
};
